import { sum } from '../utils/aggregators';
import { asCurrency } from '../utils/formatters';

export default [
  {
    displayName: 'Site Infrastructure',
    accessor: 'siteInfrastructure',
    aggregator: sum,
    color: '#87d3f8',
    defaultShown: true,
    format: asCurrency,
  },
  {
    displayName: 'Genetic Stock',
    accessor: 'geneticStock',
    aggregator: sum,
    color: '#8884d8',
    defaultShown: true,
    format: asCurrency,
  },
];
